import createHashedFingerprint from './createHashedFingerprint';
import createRollbarPerson from './createRollbarPerson';

function rollbarPayloadTransformer(payload, currentUser) {
  payload.fingerprint = createHashedFingerprint(payload); // eslint-disable-line
  payload.person = createRollbarPerson(currentUser); // eslint-disable-line
}

export default rollbarPayloadTransformer;
